import { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { useCheckout } from '@/components/CheckoutContext';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const { open } = useCheckout();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll(); // evaluate once on mount in case page is already scrolled
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="floating-cta"
      className="fixed inset-x-0 bottom-0 z-40 pointer-events-none"
    >
      {/* ───────── Mobile: full-width bottom bar ───────── */}
      {/* Right padding reserves room so the bar never sits under
          the SupportWidget (which floats at bottom-24 right-4 on mobile). */}
      <div className="sm:hidden">
        <div
          className="pt-3 pb-4 pl-4 pr-20"
          style={{
            background: 'linear-gradient(to top, #FFF7CD 70%, transparent)',
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)',
          }}
        >
          <button
            data-testid="floating-cta-button"
            data-variant="mobile"
            onClick={() => open('floating_cta')}
            className="btn-accent cta-pulse pointer-events-auto w-full inline-flex items-center justify-center gap-2 text-sm px-5 py-4 group"
          >
            🚀 Grab Bundle Now &bull; ₹999
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </div>

      {/* ───────── Desktop: centered floating pill ───────── */}
      {/* Right padding on the container shifts the pill slightly left so it
          stays clear of the SupportWidget at bottom-20 right-6 (56x56). */}
      <div className="hidden sm:flex justify-center px-6 pb-6 pr-24">
        <button
          data-testid="floating-cta-button"
          data-variant="desktop"
          onClick={() => open('floating_cta')}
          className="btn-accent cta-pulse pointer-events-auto inline-flex items-center justify-center gap-3 text-sm md:text-base px-7 py-4 group"
          style={{
            boxShadow:
              '0 12px 40px -8px rgba(253,195,161,0.55), 0 4px 12px rgba(0,0,0,0.06)',
          }}
        >
          🚀 Grab Bundle Now &bull; ₹999
          <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
}
